import React from "react"
import { Link } from "gatsby"

import { FiChevronRight } from "react-icons/fi"

import * as style from "./Guides.module.scss"

const Category = ({ category }) => (
  <div className={style.category}>
    <header>
      <Link to={category.path}>{category.title}</Link>
    </header>
    {category.subPages?.map((page) => (
      <Link key={page.id} to={page.path}>
        {page.title}
      </Link>
    ))}
    {category.quickstarts?.map((page) => (
      <Link key={page.id} to={page.path}>
        {page.title}
      </Link>
    ))}
    {category.subcategories?.map((subcategory) => (
      <Link key={subcategory.id} to={subcategory.path}>
        {subcategory.title}
        <FiChevronRight />
      </Link>
    ))}
  </div>
)

export default Category
